import { Card, Heading, Icon } from '@frontendmentorio/design-system-v2';

export default function More() {
  return (
    <div className="px-5">
      <div className="container-xl flex flex-col gap-6 py-8 tablet:gap-7">
        <Heading level="4" tagName="h2">
          Plus, more ways to stand out with Pro…
        </Heading>

        <ul className="flex flex-col gap-5 max-w-prose tablet:grid tablet:grid-cols-2 tablet:max-w-none">
          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="eye-slash" />
            </span>

            <Heading level="5" tagName="h3">
              Private solutions
            </Heading>

            <p className="text-neutral-500">
              Control what you showcase by making selected solutions private. 
              Hide any work you're not ready to share, so your profile displays 
              only your best and most relevant projects.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="infinity" />
            </span>

            <Heading level="5" tagName="h3">
              Unlimited solution screenshots
            </Heading>

            <p className="text-neutral-500">
              Perfect your submissions without limits. Compare your work to the
              original design as often as needed and update your code and
              screenshots until your solution matches the design.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon className="text-blue-500 text-2xl" name="globe" />
            </span>

            <Heading level="5" tagName="h3">
              Custom solution domains
            </Heading>

            <p className="text-neutral-500">
              Share your work your way. Make it easy for others to browse your 
              portfolio, learn more about you, and view your other work whenever 
              they review your solutions.
            </p>
          </Card>

          <Card className="flex flex-col gap-4 p-5" tagName="li">
            <span className="aspect-square bg-blue-100 flex-center rounded-lg w-[4.5rem]">
              <Icon
                className="text-blue-500 text-2xl"
                name="bolt-lightning"
              />
            </span>

            <Heading level="5" tagName="h3">
              Instant access to community solutions
            </Heading>

            <p className="text-neutral-500">
              Learn from others, faster. View community solutions immediately
              without submitting your own, making it easier to learn new
              techniques and get unstuck when you need help.
            </p>
          </Card>
        </ul>
      </div>
    </div>
  );
}
